/**
 * @param {jQuery} $
 * @param {AppConfig} config
 * @param {AppLibrary} library
 * @param {Customer} customerObj
 * @constructor
 */
export let TabTerms = function ($, config, library, customerObj) {
  /**
   * @type {string}
   */
  let template = `
<div class="slp-tab-grid">
    <div class="slp-tab-grid-row">
        <div class="slp-tab-grid-col slp-wide">
            `+ config.getPopupText().termsContent  +`
        </div>
    </div>
<!--    <div class="slp-tab-grid-row">-->
<!--        <div class="slp-tab-grid-col slp-wide">-->
<!--             <strong>{{max_points_part}}%</strong> of order can be paid at the cart page using {{plural}}.-->
<!--        </div>-->
<!--    </div>-->
<!--    <div class="slp-tab-grid-row">-->
<!--        <div class="slp-tab-grid-col slp-wide">-->
<!--              1 {{singular}} can give you <strong>{{&spend_rate}}</strong> discount.-->
<!--        </div>-->
<!--    </div>-->
<!--    <div class="slp-tab-grid-row">-->
<!--        <div class="slp-tab-grid-col slp-wide">-->
<!--              You will receive {{plural}} for the purchase when the order receives <strong>&quot;Paid&quot;</strong> status.-->
<!--        </div>-->
<!--    </div>-->
</div>        
`;

  /**
   * @type {{tab: string, heading: string}}
   */
  let texts = config.getTexts().popup_pages.text.terms;

  /**
   * @return {string}
   */
  this.getTitle = () => {
    return texts;
  };

  /**
   * @return {string}
   */
  this.getBody = () => {
    return library.mustache().render(
      config.customization().tabTermsTemplate || template,
      {
        min_subtotal: library.formatMoney(config.getMinSubTotal()),
        spend_rate: library.formatMoney(config.getRedeemRate())
      }
    );
  };

  /**
   * @param {HTMLElement} tabsContainer
   */
  this.afterDisplay = (tabsContainer) => {

  };

};

